module.exports = __webpack_public_path__ + "img/7.6d26f1e6.png";